import { render, staticRenderFns } from "./TextoLongo.vue?vue&type=template&id=673b9a70"
import script from "./TextoLongo.vue?vue&type=script&lang=js"
export * from "./TextoLongo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports